export const firebaseConfig = {
    apiKey: "AIzaSyCPL0093rwFyA53AO8Mma4mRSG57mXck2M",
    authDomain: "dogoo-b6a1d.firebaseapp.com",
    projectId: "dogoo-b6a1d",
    storageBucket: "dogoo-b6a1d.appspot.com",
    messagingSenderId: "843359165168",
    appId: "1:843359165168:web:a443981422fc4eb94b4035",
    measurementId: "G-TDMYXG537K"
};

export const serverKey = 'BHO4C2ro582E80xxpXDKysEVzhKw7WtfpuNFJuqD3Rv8daKhrTkYyNnkhSdr5Vb8Be4R4eHnzHo8udW4Xrg1Yec'

export const notificationCategory = "salary timekeeping shift_work salaryworkflow shiftworkflow timekeepingworkflow"

export const DELAY_DEBOUNCE = 300